<div class="fullscreen-dialog">

    <h1 mat-dialog-title>Session</h1>
    <p>
        Control access based on session controls to enable limited experiences within specific cloud applications.
    </p>


    <div class="content" mat-dialog-content>

        <mat-error *ngIf="error">
            {{error}}
        </mat-error>

        <ng-container *ngFor="let item of sessionControllers">
            <mat-checkbox (change)="setError()" class="block" [(ngModel)]="item.checked">
                {{item.name}}
            </mat-checkbox>

            <div class="ml-4 pl-4 w-[90%]" *ngIf="item.checked && item.value === 'cloudAppSecurity'">
                <mat-form-field class="inner-block">
                    <mat-select [(ngModel)]="controls.cloudAppSecurity.cloudAppSecurityType">
                        <mat-option value="monitorOnly"> Monitor only (Preview)</mat-option>
                        <mat-option value="blockDownloads"> Block downloads (Preview)</mat-option>
                        <mat-option value="mcasConfigured"> Use custom policy...</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>


             <div class="ml-4 pl-4 w-[90%]" *ngIf="item.checked && item.value === 'persistentBrowser'">
                <mat-form-field class="inner-block">
                    <mat-select [(ngModel)]="controls.persistentBrowser.mode">
                        <mat-option value="always"> Always persistent</mat-option>
                        <mat-option value="never"> Never persistent</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="ml-4 pl-4 w-[90%]" *ngIf="item.checked && item.value === 'signInFrequency'">
                <mat-radio-group (change)="onFrequencyIntervalChange()" [(ngModel)]="controls.signInFrequency.frequencyInterval">
                    <div class="">
                        <mat-radio-button value="timeBased">Periodic reauthentication</mat-radio-button>

                        <div class="ml-3 w-1/2" *ngIf="controls.signInFrequency.frequencyInterval === 'timeBased'">
                            <mat-form-field class="signin-frequency-field">
                                <input [formControl]="controls.signInFrequency.value" matInput type="number" />

                                <mat-hint *ngIf="controls.signInFrequency.type=== 'hours'"> Value  should be between 1 and 23</mat-hint>
                                <mat-hint *ngIf="controls.signInFrequency.type=== 'days'">Value should be between 1 and 365 </mat-hint>

                                <mat-error *ngIf="controls.signInFrequency.type=== 'hours'"> Value  should be between 1 and 23</mat-error>
                                <mat-error *ngIf="controls.signInFrequency.type=== 'days'">Value should be between 1 and 365 </mat-error>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-select (ngModelChange)="onSignInFrequencyTypeChange($event)" [(ngModel)]="controls.signInFrequency.type" placeholder="Select units">
                                    <mat-option  value="hours">Hours</mat-option>

                                    <mat-option value="days">Days</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <mat-radio-button value="everyTime"> Every time </mat-radio-button>
                </mat-radio-group>
            </div>


            <div class="ml-4 pl-4 w-[90%]" *ngIf="item.checked && item.value === 'continuousAccessEvaluation'">

                <mat-radio-group [(ngModel)]="controls.continuousAccessEvaluation.mode">
                    <mat-radio-button value="disabled">Disable</mat-radio-button>



                    <mat-radio-button value="strictLocation"> Strictly enforce location policies (Preview)
                    </mat-radio-button>
                </mat-radio-group>
            </div>



        </ng-container>
    </div>

</div>

<mat-divider></mat-divider>
<mat-dialog-actions class="dialog-footer">
    <button mat-raised-button [disabled]="error" (click)="save()" color="primary">
        Save
    </button>

    <button mat-dialog-close mat-raised-button>
        Cancel
    </button>
</mat-dialog-actions>
